// extracted by mini-css-extract-plugin
export var container = "components-home-__PageLinks-module___container";
export var link = "components-home-__PageLinks-module___link";
export var linkContent = "components-home-__PageLinks-module___linkContent";
export var linkIcon = "components-home-__PageLinks-module___linkIcon";
export var linkMedia = "components-home-__PageLinks-module___linkMedia";
export var linkText = "components-home-__PageLinks-module___linkText";
export var linkTitle = "components-home-__PageLinks-module___linkTitle";
export var linksContainer = "components-home-__PageLinks-module___linksContainer";